import "@/App.css";
import HoldingPage from "@/pages/HoldingPage";
import AIServicesPage from "@/pages/AIServicesPage";

function App() {
  const host = window.location.hostname;
  const params = new URLSearchParams(window.location.search);
  // aiservices.aaen.ai -> AI Services site. ?site=ai lets us preview it on the dev URL.
  const isAIServices =
    host.startsWith("aiservices.") || params.get("site") === "ai";

  return isAIServices ? <AIServicesPage /> : <HoldingPage />;
}

export default App;
